import { ApiEndpoints } from '../constantes/ApiEndpoints';
import {
  SendOtpRequest,
  SendOtpResponse,
  ValidateOtpRequest,
  ValidateOtpResponse,
  ValidateResetPasswordOtpRequest,
  ValidateResetPasswordOtpResponse
} from '../_types/otp.types';
import { apiUserAccount } from '../../../utils/ApiService';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';
import { generateDeviceData } from './AccountService';

// export const sendOtpService = async (data: SendOtpRequest): Promise<SendOtpResponse> => await apiUserAccount.post<SendOtpResponse>(ApiEndpoints.auth.requestOtpCode, data);
//
// export const validateOtpService = async (data: ValidateOtpRequest): Promise<ValidateOtpResponse> => await apiUserAccount.post<ValidateOtpResponse>(ApiEndpoints.auth.validateOtpCode, data);
//
// export const validateOtpForgotPasswordCode = async (
//   data: ValidateResetPasswordOtpRequest
// ): Promise<ValidateResetPasswordOtpResponse> => await apiUserAccount.post<ValidateResetPasswordOtpResponse>(
//   ApiEndpoints.account.recoveryCheckCode,
//   data
// );

export const useOtpService = () => ({
  sendOtp: async (data: SendOtpRequest, accessToken?: string): Promise<SendOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();

    const headers: any = {};

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    if (data?.captchaToken) {
      headers['X-Challenge-Verify'] = data.captchaToken;
      headers['X-Challenge-Host'] = process.env.REACT_APP_TURNSTILE_HOST;
    }

    return await apiUserAccount.post<SendOtpResponse>(`${ApiEndpoints.auth.requestOtpCode}?schemaId=${schemaId}`, data, { headers });
  },
  
  validateOtp: async (data: ValidateOtpRequest): Promise<ValidateOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();
    const deviceData = await generateDeviceData();
    
    return await apiUserAccount.post<ValidateOtpResponse>(`${ApiEndpoints.auth.validateOtpCode}?schemaId=${schemaId}`, {
      ...data,
      deviceData
    });
  },
  
  validateOtpForgotPasswordCode: async (data: ValidateResetPasswordOtpRequest): Promise<ValidateResetPasswordOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();

    return await apiUserAccount.post<ValidateResetPasswordOtpResponse>(`${ApiEndpoints.account.recoveryCheckCode}?schemaId=${schemaId}`, data)
  }
});
